import React from 'react';
import { Box, Typography, Stack, TextField } from '@mui/material';

interface BasicInfoSectionProps {
  priority: number;
  modifier: string;
  isDisabled: boolean;
  onModifierChange: (value: string) => void;
}

export const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  priority,
  modifier,
  isDisabled,
  onModifierChange
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
        Basic Information
      </Typography>
      <Stack direction="row" spacing={2}>
        <TextField
          label="Priority"
          type="number"
          size="small"
          value={priority}
          sx={{ width: 120 }}
          required
          helperText="Use grid arrows to reorder"
          InputProps={{ readOnly: true }}
          disabled
        />
        <TextField
          label="Modifier"
          size="small"
          value={modifier}
          onChange={(e) => onModifierChange(e.target.value)}
          disabled={isDisabled}
          sx={{
            width: 120,
            '& .MuiInputBase-input': {
              backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
            }
          }}
          helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : ''}
        />
      </Stack>
    </Box>
  );
};
